import React from 'react';

import Highlight from '@components/FeedItems/Highlight';
import NewsletterFeedItem from '@components/FeedItems/NewsletterFeedItem';
import LazyImgixImage from '@components/LazyImgixImage';
import useEventTracking from '@hooks/useEventTracking';
import { NewsletterCard as NewsletterCardType } from '@interfaces/homepage';
import { highlight_path } from '@routes';
import { ClickTarget, click } from '@tracking';

interface NewsletterCardProps {
  newsletter: NewsletterCardType;
  contentIndex: number;
}

const NewsletterCard = ({ newsletter, contentIndex }: NewsletterCardProps) => {
  const { author, cardImageUrl, description, frequency, name, id, slug } = newsletter;
  const link = highlight_path(slug);
  const { trackEvent } = useEventTracking();

  return (
    <NewsletterFeedItem
      newsletterId={id}
      newsletterAuthor={author}
      contentIndex={contentIndex}
      key={`featured-newsletter-${contentIndex}-${id}`}
      className="flex flex-col pb-36 sm:w-min sm:pb-0"
    >
      {cardImageUrl && (
        <a
          href={link}
          onClickCapture={() => trackEvent(click({ clickTarget: ClickTarget.ArticleImage }))}
          className="relative block flex-shrink-0 max-sm:h-[calc(100vw*9/16)] sm:h-[calc(213px*9/16)] sm:w-[213px] lg:h-[calc(257px*9/16)] lg:w-[257px]"
        >
          <LazyImgixImage
            alt={name}
            className="article-image aspect-[16/9] h-auto w-full object-cover"
            src={cardImageUrl}
            sizes="(min-width: 1200px) 500px, (min-width: 768px) 300px, (min-width: 480px) 600px, 400px"
            wrapperClassName="!flex"
          />
        </a>
      )}
      <div className="mt-8 sm:mt-12">
        <Highlight highlight={frequency} customPath={link} />
        <h3 className="featured-newsletter-name my-0 font-suisse-neue text-headline-xxs text-black transition-colors duration-200 hover:text-primary-magenta md:text-subheadline-sm dark:hover:text-primary-pink">
          <a
            href={link}
            onClickCapture={() =>
              trackEvent(
                click({
                  clickTarget: ClickTarget.FeaturedNewsletterName,
                  clickText: name,
                })
              )
            }
          >
            {name}
          </a>
        </h3>
        <p className="my-0 font-suisse-screen text-byline-sm">{description}</p>
      </div>
    </NewsletterFeedItem>
  );
};

export default NewsletterCard;
